import { render, staticRenderFns } from "./business-dispatch.vue?vue&type=template&id=5300b804&scoped=true"
import script from "./business-dispatch.vue?vue&type=script&lang=js"
export * from "./business-dispatch.vue?vue&type=script&lang=js"
import style0 from "./business-dispatch.vue?vue&type=style&index=0&id=5300b804&prod&lang=less"
import style1 from "./business-dispatch.vue?vue&type=style&index=1&id=5300b804&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5300b804",
  null
  
)

export default component.exports